export class VehicleFilter {
    plateNumber: string;
    isTruck: boolean;
}


// WEBPACK FOOTER //
// ./src/app/models/vehicles/vehicleFilter.ts